import type { TourItemKey } from '../hooks/use-tour-store';

export interface TourStepStrings {
  title: string;
  description: string;
}

interface TourStepVariants {
  poll: TourStepStrings;
  wordcloud: TourStepStrings;
}

const TOUR_STRINGS_BY_TYPE: Record<TourItemKey, TourStepVariants> = {
  WELCOME_MODAL: {
    poll: {
      title: '',
      description: '',
    },
    wordcloud: {
      title: '',
      description: '',
    },
  },
  WRITE_QUESTION: {
    poll: {
      title: 'ASK AWAY.',
      description:
        'Multiple-choice slides are great for polls, quizzes and interactive learning.',
    },
    wordcloud: {
      title: 'ASK AWAY.',
      description:
        'Word clouds are great for brainstorming, visualizing audience perspectives, and keeping people engaged.',
    },
  },
  EDIT_CONTENT: {
    poll: {
      title: 'CLICK TO EDIT.',
      description:
        'You can add or remove options for your audience to vote on.',
    },
    wordcloud: {
      title: 'CLICK TO EDIT.',
      description: 'You decide how the audience can respond to your questions.',
    },
  },
  EDIT_OPTIONS: {
    poll: {
      title: 'ADD ANSWERS.',
      description:
        'These will be the options to vote on, and you can decide how the voting works.',
    },
    wordcloud: {
      title: 'SET NUMBER OF RESPONSES.',
      description:
        'One per participant, or full-on ramble mode? You’re in charge.',
    },
  },
  PRESS_PRESENT: {
    poll: {
      title: 'PRESENT MODE.',
      description:
        "When it's time to collect votes, switch to Present mode. Try it now to see what it looks like for you and your participants.",
    },
    wordcloud: {
      title: 'PRESENT MODE.',
      description:
        "When it's time to collect votes, switch to Present mode. Try it now to see what it looks like for you and your participants.",
    },
  },
  QR_CODE: {
    poll: {
      title: 'HOW TO JOIN.',
      description:
        'Participants can use this QR code or join on menti.com with the code at the top of the slide. Try it on your phone, or hit "Next."',
    },
    wordcloud: {
      title: 'HOW TO JOIN.',
      description:
        'Participants can use this QR code or join on menti.com with the code at the top of the slide. Try it on your phone, or hit "Next."',
    },
  },
  NAVIGATION_ARROWS: {
    poll: {
      title: 'The audience follows you.',
      description:
        "Use arrow keys or slide controls to move through the presentation. Your audience follows along and votes on the slide you're showing them.",
    },
    wordcloud: {
      title: 'The audience follows you.',
      description:
        "Use arrow keys or slide controls to move through the presentation. Your audience follows along and votes on the slide you're showing them.",
    },
  },
  FINISH_MODAL: {
    poll: {
      title: '',
      description: '',
    },
    wordcloud: {
      title: '',
      description: '',
    },
  },
} as const;

export const getTourStrings = (
  tourItemKey: TourItemKey,
  appliedQuickAction?: 'poll' | 'wordcloud' | null,
) => {
  const quickAction = appliedQuickAction || 'poll';
  return TOUR_STRINGS_BY_TYPE[tourItemKey][quickAction];
};
